import "./Footer.css";
import { IconWhatsapp } from "../../icons/Icons";

function Footer() {
  return (
    <footer className="adc-footer">
      <div className="adc-footer-inner">
        <div className="adc-footer-grid">

          <div className="adc-footer-column adc-footer-brand">
            <a href="/" className="adc-footer-logo-link" aria-label="ADC Aircraft Service & Part">
              <img src="/image/ADC-Logo2.png" alt="ADC Aircraft Service & Part" />
            </a>

            <div className="adc-footer-brand-text">
              <p className="adc-footer-description">
                We are specialists in aircraft parts, committed to quality, safety, and efficiency.
              </p>
            </div>
          </div>


          <div className="adc-footer-column adc-footer-contact">
            <span className="adc-footer-label">Contact us</span>

            <h4 className="adc-footer-heading">Need support or a quick quote?</h4>

            <a
              href="https://wa.me/19545737027?text=Hello%2C%20I%20would%20like%20to%20speak%20with%20an%20agent."
              target="_blank"
              rel="noopener noreferrer"
              className="adc-footer-whatsapp"
            >
              {IconWhatsapp}
              <span>Chat with us on WhatsApp</span>
            </a>

            <div className="adc-footer-contact-list">
              <a href="tel:+19545737027" className="adc-footer-contact-item">
                <span className="adc-footer-contact-icon">
                  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                    <path
                      d="M6.6 10.8a15.5 15.5 0 0 0 6.6 6.6l2.2-2.2a1 1 0 0 1 1-.24c1.08.36 2.23.54 3.4.54a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.3 21 3 13.7 3 4.8a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.17.18 2.32.54 3.4a1 1 0 0 1-.24 1l-2.2 2.2Z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
                <span>+1 954 573 7027</span>
              </a>

              <a href="mailto:support@adcaircraft.com" className="adc-footer-contact-item">
                <span className="adc-footer-contact-icon">
                  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                    <path
                      d="M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v11a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 17.5v-11Zm2 .5v.18l5.55 4.32a.75.75 0 0 0 .9 0L18 7.18V7a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1Zm12 2.08-4.63 3.6a2.25 2.25 0 0 1-2.74 0L6 9.08V17a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V9.08Z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
                <span>support@adcaircraft.com</span>
              </a>
            </div>
          </div>

          <div className="adc-footer-column adc-footer-links">
            <div className="adc-footer-links-group">
              <span className="adc-footer-label">Information</span>

              <div className="adc-footer-links-list">
                <a href="/terms-and-conditions" className="adc-footer-link-item">
                  Terms &amp; conditions
                </a>
                <a href="/about-us" className="adc-footer-link-item">
                  About us
                </a>
                <a href="/payment-information" className="adc-footer-link-item">
                  Payment information
                </a>
              </div>
            </div>

            <div className="adc-footer-links-group">
              <span className="adc-footer-label">Follow us</span>

              <div className="adc-footer-socials">
                <a
                  href="https://www.facebook.com/profile.php?id=61580435235833&sk=about"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="adc-footer-social adc-footer-social-facebook"
                  aria-label="Facebook"
                >
                  <span className="adc-footer-social-icon">
                    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
                      <path
                        d="M13.5 21V13.8H15.9L16.3 10.8H13.5V8.95C13.5 8.08 13.74 7.48 14.98 7.48H16.4V4.78C16.15 4.75 15.28 4.68 14.27 4.68C12.17 4.68 10.73 5.96 10.73 8.31V10.8H8V13.8H10.73V21H13.5Z"
                        fill="currentColor"
                      />
                    </svg>
                  </span>
                  <span>Facebook</span>
                </a>

                <a
                  href="https://www.instagram.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="adc-footer-social adc-footer-social-instagram"
                  aria-label="Instagram"
                >
                  <span className="adc-footer-social-icon">
                    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" aria-hidden="true">
                      <rect
                        x="3.25"
                        y="3.25"
                        width="17.5"
                        height="17.5"
                        rx="5.2"
                        stroke="currentColor"
                        strokeWidth="1.8"
                      />
                      <circle
                        cx="12"
                        cy="12"
                        r="4.1"
                        stroke="currentColor"
                        strokeWidth="1.8"
                      />
                      <circle cx="17.2" cy="6.9" r="1.15" fill="currentColor" />
                    </svg>
                  </span>
                  <span>Instagram</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="adc-footer-bottom">
        <p>
          © {new Date().getFullYear()} ADC Aircraft Service &amp; Part · Powered by{" "}
          <a
            href="https://www.facebook.com/people/NB-Nexus-Bridge/61586295339350"
            target="_blank"
            rel="noopener noreferrer"
            className="adc-footer-powered-link"
          >
            NB: Nexus Bridge
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;